

import React from 'react';
import { RiShareLine } from 'react-icons/ri';
import referImage from '../../assets/refer.png'; 
import { BiChevronLeft } from "react-icons/bi";

const MyReferal = () => {
  return (
    <div className="w-full mx-auto p-6 border bg-white rounded-lg mt-2">
      {/* Header Section */}
      <div className="flex justify-between items-center mb-6">
        <div className="text-[#FF9630] font-semibold text-lg mb-4 flex items-center">
          <BiChevronLeft size={24} className="mr-1" /> Referral & Earn
        </div>

        <div className="bg-orange-100 text-[#FF9630] px-4 py-1 rounded-full text-sm font-semibold">
          Total Referrals: <span>22</span>
        </div>
      </div>

      {/* Image Section */}
      <div className="flex justify-center mb-6">
        <img src={referImage} alt="Referral illustration" className="w-full max-w-xs" />
      </div>

      {/* Referral Link Section */}
      <div className="flex items-center border border-gray-300 rounded-lg overflow-hidden">
        <input
          type="text"
          readOnly
          value="moveonwheels.com/?refer=Ranjita00123"
          className="flex-grow p-3 text-gray-600 outline-none"
        />
        <button className="bg-[#FF9630] text-white px-4 py-4 font-semibold flex items-center">
          <RiShareLine className="w-5 h-5 mr-1" />
          SHARE
        </button>
      </div>
    </div>
  );
};

export default MyReferal;
